export default "__VITE_ASSET__DXgFXPAy__"